<template>
  <ul class="sidebar-menu" style="margin-top: 26px; margin-left: 9px;" data-widget="tree">
    <!-- <div class="sidebar-menu"><li class="header">Dash Board</li><router-link tag="li" class="pageLink" to="/dashboard"><a><i class="fa fa-user"></i><span class="page">Dashboard</span>main-sidebar
        </a></router-link></div>  -->
    <div v-if="this.key != 'reportManager' && this.key != 'monitoringManager'" class="sidebar-menu">
      <!-- <li class="header">Waste Transactions</li> -->
      <li class="header">Management</li>
      <!-- <img class="img_top" src="../../../../static/img/sidebarIcon/Management.png" alt="Management.png"> -->
      <router-link tag="li" class="pageLink" to="/primarytrip" active-class="active">
        <a>
          <img src="../../../../static/img/sidebarIcon/primaryTrip.png" alt="primaryTrip.png">
          <span class="page">Primary Trips </span>
        </a>
      </router-link>
      <!--
      <router-link tag="li" class="pageLink" to="/transfer-point-trip" active-class="active"><a><svg
            id="mode_of_travel_black_24dp_1_"
            data-name="mode_of_travel_black_24dp (1)"
				xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            viewBox="0 0 30 30"
          ><rect
              id="Rectangle_6341"
              data-name="Rectangle 6341"
              width="30"
              height="30"
              fill="none"
            /><path
              id="Path_23896"
              data-name="Path 23896"
              d="M18.138,23.125Q16.337,25,14,27,4.006,18.469,4,12.25A9.943,9.943,0,0,1,14,2a9.9,9.9,0,0,1,9.962,9.375h4.413L22.75,17l-5.625-5.625h4.337A7.39,7.39,0,0,0,14,4.5a7.443,7.443,0,0,0-7.5,7.75c0,2.925,2.438,6.8,7.5,11.425q1.2-1.106,2.213-2.137A3.125,3.125,0,1,1,19,23.25,2.824,2.824,0,0,1,18.138,23.125Z"
              transform="translate(1 0.5)"
              fill="#000"
            /></svg><span class="page">Transfer Point Trips</span></a></router-link><router-link tag="li" class="pageLink" to="/Segregation-plant-trip" active-class="active"><a><svg
            id="room_black_24dp_1_"
            data-name="room_black_24dp (1)"
				xmlns="http://www.w3.org/2000/svg"
            width="32.309"
            height="32.309"
            viewBox="0 0 32.309 32.309"
          ><path
              id="Path_1"
              data-name="Path 1"
              d="M0,0H32.309V32.309H0Z"
              fill="none"
            /><path
              id="_8665856_route_location_icon"
              data-name="8665856_route_location_icon"
              d="M19.283,14.833h-4.45a1.483,1.483,0,0,1,0-2.967h4.45s4.45-4.96,4.45-7.417a4.45,4.45,0,0,0-8.9,0c0,1.182,1.032,2.938,2.1,4.45h-2.1a4.45,4.45,0,1,0,0,8.9h4.45a1.483,1.483,0,0,1,0,2.967H8.6a32.023,32.023,0,0,1-2.19,2.967H19.283a4.45,4.45,0,1,0,0-8.9Zm0-11.867A1.483,1.483,0,1,1,17.8,4.45,1.479,1.479,0,0,1,19.283,2.967ZM4.45,11.867A4.451,4.451,0,0,0,0,16.317c0,2.457,4.45,7.417,4.45,7.417s4.45-4.96,4.45-7.417A4.451,4.451,0,0,0,4.45,11.867Zm0,5.933a1.483,1.483,0,1,1,1.483-1.483A1.479,1.479,0,0,1,4.45,17.8Z"
              transform="translate(7.267 4)"
              fill="#000"
            /></svg><span class="page">Segregation Plant Trips</span></a></router-link> -->
      <!--       
      <router-link tag="li" class="pageLink" to="/wasteSegregation" active-class="active"><a><svg
				xmlns="http://www.w3.org/2000/svg"
            width="21.806"
            height="29.067"
            viewBox="0 0 21.806 29.067"
          ><g
              id="trash_1_"
              data-name="trash (1)"
              transform="translate(-75.2 -15)"
            ><path
                id="Path_23885"
                data-name="Path 23885"
                d="M76.876,28.357l.507,4.016.259,2.081v.006l1.031,8.189a1.579,1.579,0,0,0,.923,1.3c.006.006.018.006.024.012.024.006.042.012.06.018s.054.018.078.024c.006.006.006.006.012.006a1.109,1.109,0,0,0,.253.048,1.022,1.022,0,0,0,.139.006h11.88a1.068,1.068,0,0,0,.139-.006,1.873,1.873,0,0,0,.253-.048c.006-.006.006-.006.012-.006.03-.006.054-.018.078-.024s.042-.012.06-.018.018-.006.024-.012a1.559,1.559,0,0,0,.923-1.3l1.031-8.189v-.006l.259-2.081.507-4.016Zm19.418-4.613H75.912a.713.713,0,0,0-.712.712v2.28a.713.713,0,0,0,.712.712H96.294a.713.713,0,0,0,.712-.712v-2.28A.713.713,0,0,0,96.294,23.744ZM95.1,22.834l-1.447-6.718A1.305,1.305,0,0,0,92.447,15h-.573l-.452,4.318a1.993,1.993,0,0,1-.139.573A2.1,2.1,0,0,1,89.335,21.2H82.871a2.088,2.088,0,0,1-1.948-1.309,2.274,2.274,0,0,1-.139-.573L80.332,15h-.579a1.31,1.31,0,0,0-1.206,1.116L77.1,22.834Z"
                transform="translate(0 0)"
                fill="#000"
              /><path
                id="Path_23886"
                data-name="Path 23886"
                d="M175.925,19.559a1.18,1.18,0,0,0,1.1.742h6.465a1.19,1.19,0,0,0,1.17-.959c.006-.036.012-.078.018-.115l.44-4.227H175.4l.446,4.233A1.167,1.167,0,0,0,175.925,19.559Z"
                transform="translate(-94.158 0)"
                fill="#000"
              /></g></svg><span class="page">Waste Segregation</span></a></router-link> -->
      <router-link tag="li" class="pageLink" to="/surveys" active-class="active"><a><img src="../../../../static/img/surveryIcon.png" alt="surveryIcon.png" ><span class="page">Surveys</span></a></router-link>
      <router-link tag="li" class="pageLink" to="/houses" active-class="active">
        <a>
          <img src="../../../../static/img/sidebarIcon/houseIcon.png" alt="houseIcon.png">
          <span class="page">Houses</span>
        </a>
      </router-link>
    </div>
    <div class="sidebar-menu">
      <!-- <li class="header">Monitoring</li> -->
      <li class="header">Monitoring</li>
      <!-- <img src="../../../../static/img/sidebarIcon/Monitoring.png" alt="Monitoring.png"> -->
      <!-- <router-link tag="li" class="pageLink" to="/vehicle-tracking" active-class="active"><a><img src="/static/img/monitoring_vehilcle.png" alt="" style="width:17px; margin-right: 3px;"><span class="page">Vehicle Tracking</span></a></router-link> -->
      <!-- <router-link tag="li" class="pageLink" to="/route-tracking" active-class="active"><a><img src="/static/img/monitoring_vehilcle.png" alt="" style="width:17px; margin-right: 3px;"><span class="page">Route Tracking</span></a></router-link> -->
      <router-link tag="li" class="pageLink" to="/route-tracking" active-class="active">
        <a>
          <!-- <img src="/static/img/monitoring_vehilcle.png" alt="" style="width:17px; margin-right: 3px;"> -->
          <img src="../../../../static/img/sidebarIcon/vehicleMonitoringIcon.png" alt="vehicleMonitoringIcon.png">
          <span class="page">Route Tracking</span>
        </a>
      </router-link>
      <!-- <router-link tag="li" class="pageLink" to="/monitoring" active-class="active"><a><img src="../../../../static/img/sidebarIcon/surveyMonitoring.png" alt="surveyMonitoring.png" ><span class="page">Surveyor Tracking</span></a></router-link> -->
    </div>
    <!-- </div> -->
    <!-- <div class="sidebar-menu"><li class="header">Expenses</li><router-link tag="li" class="pageLink" to="/dailywages" active-class="active"><a><svg
					xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="30.311"
            viewBox="0 0 25 30.311"
          ><g
              id="Group_17329"
              data-name="Group 17329"
              transform="translate(-7.505 -1.246)"
            ><path
                id="Path_23874"
                data-name="Path 23874"
                d="M11.347,36.736H8.032a.527.527,0,0,0-.528.528V48.578a.528.528,0,0,0,.527.527h3.315a1.15,1.15,0,0,0,1.15-1.15V37.886a1.15,1.15,0,0,0-1.149-1.15Z"
                transform="translate(0 -17.549)"
                fill="#000"
              /><path
                id="Path_23875"
                data-name="Path 23875"
                d="M38.4,38.516a1.923,1.923,0,0,0-1.61-.867h-1.3a2.805,2.805,0,0,0-2.6,1.74,2.907,2.907,0,0,1-.518.818A4.235,4.235,0,0,1,29,42.128H25.149a.682.682,0,0,1,0-1.365h3.83a2.567,2.567,0,0,0,1.377-.443V40.3a2.638,2.638,0,0,0-2.638-2.648H24.894A3.911,3.911,0,0,0,22.115,38.8l-.072.072a3.664,3.664,0,0,1-1.964,1.017v7.538h10.3A7.8,7.8,0,0,0,37.55,42.7l1.014-2.361A1.922,1.922,0,0,0,38.4,38.516Z"
                transform="translate(-6.218 -18)"
                fill="#000"
              /><path
                id="Path_23876"
                data-name="Path 23876"
                d="M8.5,0A8.5,8.5,0,1,1,0,8.5,8.5,8.5,0,0,1,8.5,0Z"
                transform="translate(11.505 1.246)"
                fill="#000"
              /><path
                id="_8665454_indian_rupee_sign_icon"
                data-name="8665454_indian_rupee_sign_icon"
                d="M7.458,35.362a.747.747,0,0,1-.747.747h-.84A3.362,3.362,0,0,1,3.027,38.7L6.4,41.1a.747.747,0,0,1,.174,1.042.777.777,0,0,1-.627.314.745.745,0,0,1-.434-.139L.279,38.585a.781.781,0,0,1-.257-.837.722.722,0,0,1,.711-.518H2.6a1.869,1.869,0,0,0,1.709-1.121H.734a.747.747,0,0,1,0-1.494H4.311A1.87,1.87,0,0,0,2.6,33.494H.734A.747.747,0,0,1,.734,32H6.711a.747.747,0,0,1,0,1.494H5.394a3.341,3.341,0,0,1,.477,1.121h.839A.746.746,0,0,1,7.458,35.362Z"
                transform="translate(16.518 -27.754)"
                fill="#000"
              /></g></svg><span class="page">Daily Wages </span></a></router-link><router-link tag="li" class="pageLink" to="/fuelExpenses" active-class="active"><a><svg
            id="room_black_24dp_1_"
            data-name="room_black_24dp (1)"
					xmlns="http://www.w3.org/2000/svg"
            width="28.754"
            height="28.754"
            viewBox="0 0 28.754 28.754"
          ><path
              id="Path_1"
              data-name="Path 1"
              d="M0,0H28.754V28.754H0Z"
              fill="none"
            /><path
              id="fuel"
              d="M20.233,12.5a1.48,1.48,0,0,0-1.483,1.483V37.716A1.6,1.6,0,0,0,20.233,39.2h13.35a1.6,1.6,0,0,0,1.483-1.483V30.3h.742a.726.726,0,0,1,.742.742v2.967a1.967,1.967,0,0,0,2.225,2.225A1.967,1.967,0,0,0,41,34.008V25.85c0-1.483-2.966-2.966-2.966-4.45V16.95H36.549l-1.483-1.483V13.983A1.48,1.48,0,0,0,33.583,12.5Zm1.483,2.966H32.1V21.4H21.716Zm13.35,4.45h1.483v2.225c0,1.483,2.966,2.967,2.966,4.45v7.417a.742.742,0,1,1-1.483,0V30.3a1.6,1.6,0,0,0-1.483-1.483H35.066Z"
              transform="translate(-13.41 -11.61)"
              fill="#000"
            /><path
              id="_8665454_indian_rupee_sign_icon"
              data-name="8665454_indian_rupee_sign_icon"
              d="M9.975,36.495a1,1,0,0,1-1,1H7.853a4.5,4.5,0,0,1-3.8,3.458l4.5,3.218a1,1,0,0,1,.233,1.393,1.039,1.039,0,0,1-.838.42,1,1,0,0,1-.58-.186L.378,40.8a1.044,1.044,0,0,1-.343-1.119.965.965,0,0,1,.951-.693h2.5a2.5,2.5,0,0,0,2.285-1.5H.986a1,1,0,1,1,0-2H5.768A2.5,2.5,0,0,0,3.483,34H.986a1,1,0,0,1,0-2H8.976a1,1,0,0,1,0,2H7.216a4.467,4.467,0,0,1,.638,1.5H8.976A1,1,0,0,1,9.975,36.495Z"
              transform="translate(8.145 -20.077)"
              fill="#000"
            /></svg><span class="page">Fuel Expenses</span></a></router-link><router-link tag="li" class="pageLink" to="/vehiclemaintenance" active-class="active"><a><svg
					xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="23.08"
            viewBox="0 0 25 23.08"
          ><path
              id="settings_5_"
              data-name="settings (5)"
              d="M72.069,68.56,69.2,71.475l-.162.168-.1.1a.388.388,0,0,1-.234.072.4.4,0,0,1-.258-.1l-.054-.054-.162-.162-2.482-2.53-.132-.132-.1-.1a.584.584,0,0,1-.1-.319.408.408,0,0,1,.1-.264l.042-.048.156-.156L68.6,65.026a2.507,2.507,0,0,0-2.11-.847,4.7,4.7,0,0,0-3.174,1.533c-.042.048-.09.1-.132.138a5.845,5.845,0,0,0-1.172,5.758,1.162,1.162,0,0,1,.1.276.831.831,0,0,1-.24.811l-2.278,2.188c-.709-.721-.811-.817-.811-.817a.478.478,0,0,0-.571-.072l-.355.216c-1.364-1.388-1.941-1.947-2.128-2.621a3.347,3.347,0,0,1,.162-1.99,1.4,1.4,0,0,1,1.016-.565l.517.529a.3.3,0,0,0,.427,0L59.7,67.676a.312.312,0,0,0,0-.439l-3-3.047a.3.3,0,0,0-.427,0l-1.857,1.887a.312.312,0,0,0,0,.439l.2.2a1.512,1.512,0,0,1-.282,1c-.373.379-1.112-.06-1.593.283a13.044,13.044,0,0,0-1.461,1.262,13.845,13.845,0,0,0-2.873,4.484,6.067,6.067,0,0,0,.325,5.584c.3.331.847.667.751.042s-.252-2.819.463-3.715a3.988,3.988,0,0,1,2.885-1.689c1.178-.06,1.857.343,3.384,1.893l-.168.313a.528.528,0,0,0,.072.583s.09.1.727.745L51,83.105a2.365,2.365,0,0,0-.018,3.366,2.283,2.283,0,0,0,3.318-.012L59.8,80.533c2.951,3.144,5.608,6.455,5.608,6.455a.3.3,0,0,0,.427,0l3-3.047a.312.312,0,0,0,0-.439S65.512,80.755,62.4,77.72l2.134-2.3a.8.8,0,0,1,.8-.246,1.136,1.136,0,0,1,.27.1,5.578,5.578,0,0,0,5.65-1.19c.048-.042.09-.09.138-.138a4.882,4.882,0,0,0,1.5-3.234A2.535,2.535,0,0,0,72.069,68.56Z"
              transform="translate(-47.901 -64.1)"
              fill="#000"
            /></svg><span class="page">Vehicle Maintenance</span></a></router-link><router-link tag="li" class="pageLink" to="/miscellaneous" active-class="active"><a><svg
					xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="7"
            viewBox="0 0 25 7"
          ><g
              id="Group_17331"
              data-name="Group 17331"
              transform="translate(-35 -26)"
            ><circle
                id="Ellipse_1885"
                data-name="Ellipse 1885"
                cx="3.5"
                cy="3.5"
                r="3.5"
                transform="translate(35 26)"
                fill="#000"
              /><circle
                id="Ellipse_1886"
                data-name="Ellipse 1886"
                cx="3.5"
                cy="3.5"
                r="3.5"
                transform="translate(44 26)"
                fill="#000"
              /><circle
                id="Ellipse_1887"
                data-name="Ellipse 1887"
                cx="3.5"
                cy="3.5"
                r="3.5"
                transform="translate(53 26)"
                fill="#000"
              /></g></svg><span class="page">Misc</span></a></router-link></div> -->
    <!-- <div class="sidebar-menu"><li class="header">Income</li><router-link tag="li" class="pageLink" to="/users" active-class="active"><a><svg
            id="room_black_24dp_1_"
            data-name="room_black_24dp (1)"
					xmlns="http://www.w3.org/2000/svg"
            width="32.309"
            height="32.309"
            viewBox="0 0 32.309 32.309"
          ><path
              id="Path_1"
              data-name="Path 1"
              d="M0,0H32.309V32.309H0Z"
              fill="none"
            /><g
              id="calendar_today_black_24dp_1_"
              data-name="calendar_today_black_24dp (1)"
              transform="translate(4 3)"
            ><path
                id="Path_23877"
                data-name="Path 23877"
                d="M0,0H27V27H0Z"
                fill="none"
              /><path
                id="Path_23878"
                data-name="Path 23878"
                d="M22.25,3.25H21.125V1h-2.25V3.25H7.625V1H5.375V3.25H4.25A2.257,2.257,0,0,0,2,5.5v18a2.257,2.257,0,0,0,2.25,2.25h18A2.257,2.257,0,0,0,24.5,23.5V5.5A2.257,2.257,0,0,0,22.25,3.25Zm0,20.25h-18V8.875h18Z"
                transform="translate(0.25 0.125)"
                fill="#000"
              /></g><rect
              id="Rectangle_6339"
              data-name="Rectangle 6339"
              width="19"
              height="16"
              transform="translate(8 11)"
              fill="#000"
            /><path
              id="_8665454_indian_rupee_sign_icon"
              data-name="8665454_indian_rupee_sign_icon"
              d="M9.284,36.184a.93.93,0,0,1-.93.93H7.309A4.184,4.184,0,0,1,3.77,40.333l4.193,3a.93.93,0,0,1,.217,1.3.967.967,0,0,1-.781.391.927.927,0,0,1-.54-.173L.351,40.195a.972.972,0,0,1-.32-1.042.9.9,0,0,1,.885-.645H3.241a2.326,2.326,0,0,0,2.127-1.395H.917a.93.93,0,0,1,0-1.86H5.368A2.327,2.327,0,0,0,3.241,33.86H.917a.93.93,0,0,1,0-1.86H8.355a.93.93,0,0,1,0,1.86H6.717a4.158,4.158,0,0,1,.594,1.395H8.355A.929.929,0,0,1,9.284,36.184Z"
              transform="translate(13.014 -20)"
              fill="#000"
            /></svg><span class="page">Monthly Fee Collection </span></a></router-link><router-link tag="li" class="pageLink" to="/wasteRecycle" active-class="active"><a><svg
					xmlns="http://www.w3.org/2000/svg"
            width="29"
            height="28"
            viewBox="0 0 29 28"
          ><g id="recycling_black_24dp" transform="translate(0 -0.5)"><rect
                id="Rectangle_6335"
                data-name="Rectangle 6335"
                width="29"
                height="28"
                transform="translate(0 0.5)"
                fill="none"
              /><path
                id="Path_23879"
                data-name="Path 23879"
                d="M6.7,8.153,8.407,5.321,9.638,3.278a1.2,1.2,0,0,1,2.055,0l1.768,2.939L11.991,8.678,10.8,10.614,6.7,8.153Zm19.055,6.953-1.911-3.178-4.134,2.389,2.64,4.408H23.7A2.389,2.389,0,0,0,25.838,17.4a2.358,2.358,0,0,0,.251-1.063A2.5,2.5,0,0,0,25.754,15.106ZM18.92,24.7h1.792a2.389,2.389,0,0,0,2.138-1.326l1.732-3.453H18.92V17.531L14.142,22.31l4.779,4.779ZM11.752,19.92H6.615l-1,1.685a2.062,2.062,0,0,0-.072,1.971A2.024,2.024,0,0,0,7.356,24.7h4.4ZM7.117,16.754,9.184,18,7.547,11.438,1,13.075l2.031,1.219-.49.824a2.374,2.374,0,0,0-.084,2.294L4.4,21.306Zm13.022-11L18.586,3.159A2.421,2.421,0,0,0,16.531,2H12.314l3.727,6.212L13.986,9.443l6.559,1.637,1.637-6.559L20.139,5.751Z"
                transform="translate(0.195 0.403)"
                fill="#000"
              /></g></svg><span class="page">Waste Recycle</span></a></router-link><router-link tag="li" class="pageLink" to="/users" active-class="active"><a><svg
            id="room_black_24dp_1_"
            data-name="room_black_24dp (1)"
					xmlns="http://www.w3.org/2000/svg"
            width="32.309"
            height="32.309"
            viewBox="0 0 32.309 32.309"
          ><path
              id="Path_1"
              data-name="Path 1"
              d="M0,0H32.309V32.309H0Z"
              fill="none"
            /><path
              id="ticket"
              d="M21.041,4h5.495a1.539,1.539,0,0,1,1.539,1.539V30.77a1.538,1.538,0,0,1-1.539,1.539H21.041a4.616,4.616,0,1,0-9.231,0H6.539A1.539,1.539,0,0,1,5,30.77v0l.038-12.689L5,5.542A1.539,1.539,0,0,1,6.535,4h5.275a4.616,4.616,0,1,0,9.231,0ZM6.526,12.77H8.842a.769.769,0,1,0,0-1.539H6.526a.769.769,0,1,0,0,1.539Zm20.009-1.539H24.227a.769.769,0,0,0,0,1.539h2.308a.769.769,0,0,0,0-1.539ZM11.919,12.77H15a.769.769,0,0,0,0-1.539H11.919a.769.769,0,0,0,0,1.539Zm6.154,0H21.15a.769.769,0,0,0,0-1.539H18.073a.769.769,0,0,0,0,1.539Z"
              transform="translate(1 -2)"
              fill="#000"
              fill-rule="evenodd"
            /><path
              id="_8665454_indian_rupee_sign_icon"
              data-name="8665454_indian_rupee_sign_icon"
              d="M7.951,35.584a.8.8,0,0,1-.8.8h-.9a3.584,3.584,0,0,1-3.032,2.758L6.819,41.7A.8.8,0,0,1,7,42.815a.829.829,0,0,1-.669.335A.794.794,0,0,1,5.874,43L.3,39.02a.832.832,0,0,1-.274-.892.77.77,0,0,1,.758-.553H2.774A1.993,1.993,0,0,0,4.6,36.381H.783a.8.8,0,0,1,0-1.593H4.6a1.993,1.993,0,0,0-1.822-1.195H.783A.8.8,0,0,1,.783,32H7.155a.8.8,0,0,1,0,1.593h-1.4a3.562,3.562,0,0,1,.509,1.195h.895A.8.8,0,0,1,7.951,35.584Z"
              transform="translate(13.342 -18.751)"
              fill="#000"
            /></svg><span class="page">Penalty Collection</span></a></router-link></div> -->
    <!-- <div class="sidebar-menu"><li class="header">Report</li><router-link tag="li" class="pageLink" to="/users"><a><svg
					xmlns="http://www.w3.org/2000/svg" width="29.2" height="32.2" viewBox="0 0 29.2 32.2"><g id="assignment_ind_black_24dp_1_" data-name="assignment_ind_black_24dp (1)" transform="translate(0 3)"><path id="Path_23887" data-name="Path 23887" d="M0,0H29.2V29.2H0Z" fill="none" /><path id="Path_23888" data-name="Path 23888" d="M22.467,3.433H17.381a3.636,3.636,0,0,0-6.862,0H5.433A2.44,2.44,0,0,0,3,5.867V22.9a2.44,2.44,0,0,0,2.433,2.433H22.467A2.44,2.44,0,0,0,24.9,22.9V5.867A2.44,2.44,0,0,0,22.467,3.433Zm-8.517,0A1.217,1.217,0,1,1,12.733,4.65,1.22,1.22,0,0,1,13.95,3.433Zm0,4.867a3.65,3.65,0,1,1-3.65,3.65A3.645,3.645,0,0,1,13.95,8.3Zm7.3,14.6H6.65V21.2c0-2.433,4.867-3.772,7.3-3.772s7.3,1.338,7.3,3.772Z" transform="translate(1.65 -4)" fill="#000" /></g></svg><span class="page">Daily Worker Report</span></a></router-link><router-link tag="li" class="pageLink" to="/users"><a><svg id="assignment_black_24dp_1_" data-name="assignment_black_24dp (1)"
					xmlns="http://www.w3.org/2000/svg" width="29.21" height="29.21" viewBox="0 0 29.21 29.21"><path id="Path_23891" data-name="Path 23891" d="M0,0H29.21V29.21H0Z" fill="none" /><path id="Path_23892" data-name="Path 23892" d="M22.473,3.434H17.386a3.637,3.637,0,0,0-6.864,0H5.434A2.441,2.441,0,0,0,3,5.868V22.907a2.441,2.441,0,0,0,2.434,2.434H22.473a2.441,2.441,0,0,0,2.434-2.434V5.868A2.441,2.441,0,0,0,22.473,3.434Zm-8.52,0a1.217,1.217,0,1,1-1.217,1.217A1.221,1.221,0,0,1,13.954,3.434Zm2.434,17.039H7.868V18.039h8.52ZM20.039,15.6H7.868V13.171H20.039Zm0-4.868H7.868V8.3H20.039Z" transform="translate(0.651 0.217)" fill="#000" /></svg><span class="page">Survey Status Report</span></a></router-link><router-link tag="li" class="pageLink" to="/surveys"><a><svg id="assignment_black_24dp_1_" data-name="assignment_black_24dp (1)"
					xmlns="http://www.w3.org/2000/svg" width="29.21" height="29.21" viewBox="0 0 29.21 29.21"><path id="Path_23891" data-name="Path 23891" d="M0,0H29.21V29.21H0Z" fill="none" /><path id="Path_23892" data-name="Path 23892" d="M22.473,3.434H17.386a3.637,3.637,0,0,0-6.864,0H5.434A2.441,2.441,0,0,0,3,5.868V22.907a2.441,2.441,0,0,0,2.434,2.434H22.473a2.441,2.441,0,0,0,2.434-2.434V5.868A2.441,2.441,0,0,0,22.473,3.434Zm-8.52,0a1.217,1.217,0,1,1-1.217,1.217A1.221,1.221,0,0,1,13.954,3.434Zm2.434,17.039H7.868V18.039h8.52ZM20.039,15.6H7.868V13.171H20.039Zm0-4.868H7.868V8.3H20.039Z" transform="translate(0.651 0.217)" fill="#000" /></svg><span class="page">Survey</span></a></router-link></div> -->
    <!-- <div class="sidebar-menu"><li class="header">Schedules</li><router-link tag="li" class="pageLink" to="/users"><a><i class="fa fa-user"></i><span class="page">Track Vehicle</span></a></router-link><router-link tag="li" class="pageLink" to="/users"><a><i class="fa fa-id-card"></i><span class="page">Waste Collection</span></a></router-link><router-link tag="li" class="pageLink" to="/users"><a><i class="fa fa-key"></i><span class="page">Worker Tracking</span></a></router-link></div> -->
    <li v-if="key != 'monitoringManager'" class="header">Reports</li>
    <!-- <li v-if="key != 'monitoringManager'"><img src="../../../../static/img/sidebarIcon/Reports.png" alt="Reports.png"></li> -->
    <router-link v-if="key != 'monitoringManager'" tag="li" class="pageLink" to="/line_collection_reports" active-class="active">
      <a>
        <svg width="26px" height="26px" viewBox="0 0 512 512" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <title>report-text</title>
          <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="add" fill="#337ab7" transform="translate(42.666667, 85.333333)">
              <path d="M341.333333,1.42108547e-14 L426.666667,85.3333333 L426.666667,341.333333 L3.55271368e-14,341.333333 L3.55271368e-14,1.42108547e-14 L341.333333,1.42108547e-14 Z M330.666667,42.6666667 L42.6666667,42.6666667 L42.6666667,298.666667 L384,298.666667 L384,96 L330.666667,42.6666667 Z M149.333333,234.666667 L149.333333,266.666667 L85.3333333,266.666667 L85.3333333,234.666667 L149.333333,234.666667 Z M341.333333,234.666667 L341.333333,266.666667 L192,266.666667 L192,234.666667 L341.333333,234.666667 Z M149.333333,170.666667 L149.333333,202.666667 L85.3333333,202.666667 L85.3333333,170.666667 L149.333333,170.666667 Z M341.333333,170.666667 L341.333333,202.666667 L192,202.666667 L192,170.666667 L341.333333,170.666667 Z M149.333333,106.666667 L149.333333,138.666667 L85.3333333,138.666667 L85.3333333,106.666667 L149.333333,106.666667 Z M341.333333,106.666667 L341.333333,138.666667 L192,138.666667 L192,106.666667 L341.333333,106.666667 Z" id="Combined-Shape"></path>
            </g>
          </g>
        </svg>
        <!-- <img src="/static/img/line-reports.png" alt="" style="width:16px; margin-right: 3px;"> -->
        <!-- <img src="../../../../static/img/sidebarIcon/staffMaster.png" alt="staffMaster.png"> -->
        <span class="page">Line Collection</span>
      </a>
    </router-link>
    <router-link v-if="key != 'monitoringManager'" tag="li" class="pageLink" to="/city_collection_reports" active-class="active">
      <a>
        <svg fill="#FF0000" width="26px" height="26px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path d="M13,9a1,1,0,0,0-1-1H3A1,1,0,0,0,2,9V22H13ZM6,20H4V18H6Zm0-4H4V14H6Zm0-4H4V10H6Zm5,8H8V18h3Zm0-4H8V14h3Zm0-4H8V10h3Zm3.5-6H6V3A1,1,0,0,1,7,2H17a1,1,0,0,1,1,1v7H15V6.5A.5.5,0,0,0,14.5,6ZM22,13v9H19.5V18h-2v4H15V13a1,1,0,0,1,1-1h5A1,1,0,0,1,22,13Z" />
        </svg>
        <!-- <img src="/static/img/city_collection.png" alt="" style="width:16px; margin-right: 3px;"> -->
        <!-- <img src="../../../../static/img/sidebarIcon/staffMaster.png" alt="staffMaster.png"> -->
        <span class="page">City Collection</span>
      </a>
    </router-link>
    <!-- <router-link v-if="key != 'monitoringManager'" tag="li" class="pageLink" to="/daily_city_collection_reports" active-class="active">
      <a>
        <img src="/static/img/daily-report.png" alt="" style="width: 16px; margin-right: 3px" />
        <span class="page">Daily City Collection</span>
      </a>
    </router-link> -->
    <router-link v-if="key != 'monitoringManager'" tag="li" class="pageLink" to="/monthly_city_collection_reports" active-class="active">
      <a>
        <img src="/static/img/monthlyReport.png" alt="">
        <!-- <img src="../../../../static/img/sidebarIcon/staffMaster.png" alt="staffMaster.png"> -->
        <span class="page">Monthly City Collection</span>
      </a>
    </router-link>
    <router-link v-if="key != 'monitoringManager'" tag="li" class="pageLink" to="/ward-reports" active-class="active">
      <a>
        <!-- <img src="/static/img/ward_collection_icon.png" alt="" style="width:16px; margin-right: 3px;"> -->
        <img src="../../../../static/img/sidebarIcon/wardReport.png" alt="wardReport.png">
        <span class="page">Ward Collection</span>
      </a>
    </router-link>
    <router-link v-if="key != 'monitoringManager'" tag="li" class="pageLink" to="/trip-reports" active-class="active">
      <a>
        <!-- <img src="/static/img/car-report-icon.png" alt="" style="width:16px; margin-right: 3px;"> -->
        <img src="../../../../static/img/sidebarIcon/vehicleReport.png" alt="vehicleReport.png">
        <span class="page">Vehicle Trip</span>
      </a>
    </router-link>
    <!-- <router-link
        tag="li"
        class="pageLink"
        to="/card-reports"
        active-class="active"
      ><a><svg
								xmlns="http://www.w3.org/2000/svg"
            width="32.309"
            height="34"
            viewBox="0 0 32.309 34"
          ><g
              id="Group_17332"
              data-name="Group 17332"
              transform="translate(-31 -1507)"
            ><g
                id="room_black_24dp_1_"
                data-name="room_black_24dp (1)"
                transform="translate(31 1507)"
              ><path
                  id="Path_1"
                  data-name="Path 1"
                  d="M0,0H32.309V32.309H0Z"
                  fill="none"
                /><path
                  id="Path_2"
                  data-name="Path 2"
                  d="M14.423,2A9.416,9.416,0,0,0,5,11.423c0,7.068,9.423,17.5,9.423,17.5s9.423-10.433,9.423-17.5A9.416,9.416,0,0,0,14.423,2Zm0,12.789a3.365,3.365,0,1,1,3.365-3.365A3.367,3.367,0,0,1,14.423,14.789Z"
                  transform="translate(1.731 1.692)"
                  fill="#000"
                /></g><rect
                id="Rectangle_6342"
                data-name="Rectangle 6342"
                width="19"
                height="2"
                rx="1"
                transform="translate(38 1539)"
                fill="#000"
              /></g></svg><span class="page">Scan Card</span></a></router-link> -->
    <div v-if="
        this.key != 'superVisor' &&
        this.key != 'reportManager' &&
        key != 'monitoringManager'
      " class="sidebar-menu">
      <li class="header">Setup</li>
      <!-- <img src="../../../../static/img/sidebarIcon/Setup.png" alt="Setup.png"> -->
      <router-link tag="li" class="pageLink" to="/city" active-class="active">
        <a v-if="this.checkRole == 'Super Admin'">
          <img src="../../../../static/img/sidebarIcon/cityMaster.png" alt="cityMaster.png">
          <span class="page">City</span>
        </a>
      </router-link>
      <router-link tag="li" class="pageLink" to="/users" active-class="active" v-permission.if="['user', 'createUser']">
        <a v-if="this.checkRole == 'Super Admin'">
          <!-- <i class="fa fa-user"></i> -->
          <img src="../../../../static/img/sidebarIcon/userIcon.png" alt="userIcon.png">
          <span class="page">User</span>
        </a>
      </router-link>
      <!-- <router-link tag="li" class="pageLink" to="/permissions" v-permission.if="['permission', 'createRole']"><a><i class="fa fa-key"></i><span class="page">Permissions</span></a></router-link> -->
      <!-- <router-link tag="li" class="pageLink" to="/transport" active-class="active"><a><svg
											xmlns="http://www.w3.org/2000/svg"
          width="32.309"
          height="34"
          viewBox="0 0 32.309 34"
        ><g
            id="Group_17332"
            data-name="Group 17332"
            transform="translate(-31 -1507)"
          ><g
              id="room_black_24dp_1_"
              data-name="room_black_24dp (1)"
              transform="translate(31 1507)"
            ><path
                id="Path_1"
                data-name="Path 1"
                d="M0,0H32.309V32.309H0Z"
                fill="none"
              /><path
                id="Path_2"
                data-name="Path 2"
                d="M14.423,2A9.416,9.416,0,0,0,5,11.423c0,7.068,9.423,17.5,9.423,17.5s9.423-10.433,9.423-17.5A9.416,9.416,0,0,0,14.423,2Zm0,12.789a3.365,3.365,0,1,1,3.365-3.365A3.367,3.367,0,0,1,14.423,14.789Z"
                transform="translate(1.731 1.692)"
                fill="#000"
              /></g><rect
              id="Rectangle_6342"
              data-name="Rectangle 6342"
              width="19"
              height="2"
              rx="1"
              transform="translate(38 1539)"
              fill="#000"
            /></g></svg><span class="page">Transfer Point </span></a></router-link> -->
      <!-- <router-link tag="li" class="pageLink" to="/segregation" active-class="active"><a><svg
          id="Group_17330"
          data-name="Group 17330"
											xmlns="http://www.w3.org/2000/svg"
          width="24.49"
          height="24.49"
          viewBox="0 0 24.49 24.49"
        ><path
            id="Path_23890"
            data-name="Path 23890"
            d="M26.49,11.8V26.49H2V11.8l8.572-3.674v2.449l6.123-2.449h0V11.8ZM20.612,9.959,21.592,2h3.674l.98,7.959ZM13.021,21.592H15.47v-4.9H13.021Zm-4.9,0h2.449v-4.9H8.123Zm12.245-4.9H17.919v4.9h2.449Z"
            transform="translate(-2 -2)"
            fill="#000"
          /></svg><span class="page">Segregation Plant</span></a></router-link> -->
      <!-- <router-link tag="li" class="pageLink" to="/dumpYard" active-class="active"><a><svg
											xmlns="http://www.w3.org/2000/svg"
          width="26.85"
          height="9.823"
          viewBox="0 0 26.85 9.823"
        ><g id="Dumping" transform="translate(-0.598 -0.346)"><path
              id="Path_23894"
              data-name="Path 23894"
              d="M1.842,55.955c-1.762.49-1.273,1.885-.808,2.521L27,58.427a.817.817,0,0,0,.294-1.2c-.265-.5-1.191-.5-1.591-.22-.176-.959-1.542-1-2.2-.906-.509-.822-1.256-.326-1.566.024-.1-.255-.628-.481-.881-.563a1.7,1.7,0,0,0-.538-1.885,1.5,1.5,0,0,0-2.2.269c.139.2.318.47-.073-.1s-1.322-.3-1.738-.1c-.392-.509-.979.016-1.224.343a1.828,1.828,0,0,0-2.937-.49c-.235-1.077-1.11-.857-1.518-.612a2.263,2.263,0,0,0-1.86-1.787,2.448,2.448,0,0,0-2.888,2.032,1,1,0,0,0-.734,1.2,1.847,1.847,0,0,0-1.028,1.371A1.413,1.413,0,0,0,2.8,56.2C2.64,55.965,2.095,55.939,1.842,55.955Z"
              transform="translate(0 -48.308)"
              fill="#000"
            /><path
              id="Path_23895"
              data-name="Path 23895"
              d="M199.644,6.888a.735.735,0,0,0-.955.269l-.269-.2a2.1,2.1,0,0,0-.245-1.3,2.193,2.193,0,0,0-3.157-.783,2.139,2.139,0,0,0-1.64-.024,1.233,1.233,0,0,0-1.3.1,2.381,2.381,0,0,0-2.766-.465A1.6,1.6,0,0,0,187.969,4,2.431,2.431,0,0,0,186.5,2.556a1.854,1.854,0,0,1,1.811-1.322,1.622,1.622,0,0,1,2.717-.269,1.5,1.5,0,0,1,1.958.049A1.577,1.577,0,0,1,194.577.6c.627.02.93.857,1,1.273,1.508.137,1.542,1.216,1.371,1.738a1.233,1.233,0,0,1,.857,1A2.451,2.451,0,0,1,199.644,6.888Z"
              transform="translate(-176.801 0)"
              fill="#000"
            /></g></svg><span class="page">Dump Yard</span></a></router-link> -->
      <router-link tag="li" class="pageLink" to="/helperAndDriver" active-class="active">
        <a>
          <img src="../../../../static/img/sidebarIcon/staffMaster.png" alt="staffMaster.png">
          <span class="page">Staff</span>
        </a>
      </router-link>
      <router-link tag="li" class="pageLink" to="/wasteCollectionArea" active-class="active">
        <a>
          <img src="../../../../static/img/sidebarIcon/zoneMaster.png" alt="zoneMaster.png">
          <span class="page">Zone</span>
        </a>
      </router-link>
      <!-- <router-link tag="li" class="pageLink" to="/vendor" active-class="active"><a><svg
													xmlns="http://www.w3.org/2000/svg"
          width="22.404"
          height="20.911"
          viewBox="0 0 22.404 20.911"
        ><path
            id="group_8_"
            data-name="group (8)"
            d="M6.92,70.188a4.023,4.023,0,0,0-3.092,1.494H2.264a2.675,2.675,0,0,1-1.61-.473A1.6,1.6,0,0,1,0,69.827q0-4.119,1.447-4.119a2.226,2.226,0,0,1,.508.245,7.674,7.674,0,0,0,1.138.5,4.1,4.1,0,0,0,1.389.251,4.688,4.688,0,0,0,1.552-.268,5.818,5.818,0,0,0-.058.77,5.138,5.138,0,0,0,.945,2.987Zm12.5,7.433a2.908,2.908,0,0,1-.852,2.211,3.147,3.147,0,0,1-2.264.811H6.1a3.147,3.147,0,0,1-2.264-.811,2.908,2.908,0,0,1-.852-2.211q0-.618.041-1.208a11.885,11.885,0,0,1,.163-1.272A9.893,9.893,0,0,1,3.5,73.876,6,6,0,0,1,4,72.738a4.1,4.1,0,0,1,.723-.945,3.044,3.044,0,0,1,1-.624,3.5,3.5,0,0,1,1.3-.233,1.375,1.375,0,0,1,.5.251q.385.251.852.56a5.116,5.116,0,0,0,1.249.56,5.071,5.071,0,0,0,3.151,0,5.116,5.116,0,0,0,1.249-.56q.467-.309.852-.56a1.375,1.375,0,0,1,.5-.251,3.5,3.5,0,0,1,1.3.233,3.044,3.044,0,0,1,1,.624,4.1,4.1,0,0,1,.723.945,6,6,0,0,1,.5,1.138,9.892,9.892,0,0,1,.309,1.266,11.885,11.885,0,0,1,.163,1.272q.041.589.041,1.208ZM7.468,62.72a2.878,2.878,0,0,1-.875,2.112,2.878,2.878,0,0,1-2.112.875,2.878,2.878,0,0,1-2.112-.875,2.986,2.986,0,0,1,0-4.224,2.878,2.878,0,0,1,2.112-.875,2.878,2.878,0,0,1,2.112.875A2.878,2.878,0,0,1,7.468,62.72ZM15.683,67.2A4.482,4.482,0,0,1,11.2,71.682a4.481,4.481,0,0,1,0-8.962A4.482,4.482,0,0,1,15.683,67.2ZM22.4,69.827a1.6,1.6,0,0,1-.653,1.383,2.675,2.675,0,0,1-1.61.473H18.577a4.023,4.023,0,0,0-3.092-1.494A5.138,5.138,0,0,0,16.43,67.2a5.818,5.818,0,0,0-.058-.77,4.688,4.688,0,0,0,1.552.268,4.1,4.1,0,0,0,1.389-.251,7.674,7.674,0,0,0,1.138-.5,2.226,2.226,0,0,1,.508-.245Q22.4,65.708,22.4,69.827ZM20.911,62.72a2.987,2.987,0,0,1-5.1,2.112,2.987,2.987,0,1,1,4.224-4.224A2.878,2.878,0,0,1,20.911,62.72Z"
            transform="translate(0 -59.733)"
            fill="#000"
          /></svg><span class="page">Vendor</span></a></router-link> -->
      <router-link tag="li" class="pageLink" to="/vehicles" active-class="active">
        <a>
          <img src="../../../../static/img/sidebarIcon/vehicleMaster.png" alt="vehicleMaster.png">
          <span class="page">Vehicle</span>
        </a>
      </router-link>
    </div>
    <!-- <router-link tag="li" class="pageLink" to="/wasteType" active-class="active"><a v-if="this.checkRole == 'Super Admin'"><svg
													xmlns="http://www.w3.org/2000/svg"
          width="21.806"
          height="29.067"
          viewBox="0 0 21.806 29.067"
        ><g
            id="trash_1_"
            data-name="trash (1)"
            transform="translate(-75.2 -15)"
          ><path
              id="Path_23885"
              data-name="Path 23885"
              d="M76.876,28.357l.507,4.016.259,2.081v.006l1.031,8.189a1.579,1.579,0,0,0,.923,1.3c.006.006.018.006.024.012.024.006.042.012.06.018s.054.018.078.024c.006.006.006.006.012.006a1.109,1.109,0,0,0,.253.048,1.022,1.022,0,0,0,.139.006h11.88a1.068,1.068,0,0,0,.139-.006,1.873,1.873,0,0,0,.253-.048c.006-.006.006-.006.012-.006.03-.006.054-.018.078-.024s.042-.012.06-.018.018-.006.024-.012a1.559,1.559,0,0,0,.923-1.3l1.031-8.189v-.006l.259-2.081.507-4.016Zm19.418-4.613H75.912a.713.713,0,0,0-.712.712v2.28a.713.713,0,0,0,.712.712H96.294a.713.713,0,0,0,.712-.712v-2.28A.713.713,0,0,0,96.294,23.744ZM95.1,22.834l-1.447-6.718A1.305,1.305,0,0,0,92.447,15h-.573l-.452,4.318a1.993,1.993,0,0,1-.139.573A2.1,2.1,0,0,1,89.335,21.2H82.871a2.088,2.088,0,0,1-1.948-1.309,2.274,2.274,0,0,1-.139-.573L80.332,15h-.579a1.31,1.31,0,0,0-1.206,1.116L77.1,22.834Z"
              transform="translate(0 0)"
              fill="#000"
            /><path
              id="Path_23886"
              data-name="Path 23886"
              d="M175.925,19.559a1.18,1.18,0,0,0,1.1.742h6.465a1.19,1.19,0,0,0,1.17-.959c.006-.036.012-.078.018-.115l.44-4.227H175.4l.446,4.233A1.167,1.167,0,0,0,175.925,19.559Z"
              transform="translate(-94.158 0)"
              fill="#000"
            /></g></svg><span class="page">Waste Type</span></a></router-link> -->
  </ul>
</template>
<!-- <template><ul class="sidebar-menu" data-widget="tree"><div class="sidebar-menu" v-if="ready" v-for="item in response" :key="item"><li class="header">
                  {{ item.menuName }}
              </li><div v-for="itemSubMenu in item.subMenu" :key="itemSubMenu" ><router-link style="padding:10px 15px" v-bind="style" tag="li" class="pageLink" :to=itemSubMenu.subMenuCode><a><i class="fa fa-file"></i><span style="padding-left:5px" v-bind="style" class="page">{{ itemSubMenu.subMenuName }} </span></a></router-link></div></div></ul></template>

-->
<script>
  import {
    USER_ROLES,
    EVENTS
  } from "../../../config";
  import {
    eventBus
  } from "../../../services";
  import {
    mapState
  } from "vuex";
  import {
    authService
  } from "../../../services";
  import axios from "axios";
  export default {
    name: "SidebarName",
    data() {
      return {
        checkRole: "",
        role: "",
        key: '',
        USER_ROLES: USER_ROLES,
        ready: false,
        response: {},
      };
    },
    created() {
      this.user = this.$store.state.auth.user;
      this.key = this.$store.state.auth.user.role.key;
      this.checkRole = this.$store.state.auth.user.role.name;
      this.role = this.$store.state.auth.user.roleName ? this.$store.state.auth.user.roleName.toUpperCase() : "";
    },
    computed: {
      ...mapState({
        user1: (state) => state.auth.user,
      }),
    },
  };
</script>
<style lang="scss">
  /* override default */
  .sidebar-menu>li>a {
    padding: 12px 15px 12px 15px;
    display: flex;
    font-size: 16px;
    line-height: 25px;
    align-items: center;
  }

  .sidebar-menu li.active>a>.fa-angle-left,
  .sidebar-menu li.active>a>.pull-right-container>.fa-angle-left {
    animation-name: rotate;
    animation-duration: 0.2s;
    animation-fill-mode: forwards;
  }

  .sidebar-menu>li svg {
    width: 15px;
    height: auto;
    margin-right: 5px;
  }

  .img_top {
    width: 110px;
    margin-left: 30px;
    margin-top: 54px;
  }

  // .monitoring-wrapper > .dropdown {
  //   position: relative;
  //   display: inline-block;
  // }
  // .monitoring-wrapper > .dropdown > input[type="checkbox"] {
  //   position: absolute;
  //   left: -100vw;
  // }
  // .monitoring-wrapper > .dropdown > label,
  // .monitoring-wrapper > .dropdown > a[role="button"] {
  //   display: inline-block;
  //   padding: 6px 15px;
  //   color: #333;
  //   line-height: 1.5em;
  //   text-decoration: none;
  //   border: 1px solid #8c8c8c;
  //   cursor: pointer;
  //   -webkit-border-radius: 3px;
  //   -moz-border-radius: 3px;
  //   border-radius: 3px;
  // }
  // .monitoring-wrapper > .dropdown > label:hover,
  // .monitoring-wrapper > .dropdown > a[role="button"]:hover,
  // .monitoring-wrapper > .dropdown > a[role="button"]:focus {
  //   border-color: #333;
  // }
  // .monitoring-wrapper > .dropdown > label:after,
  // .monitoring-wrapper > .dropdown > a[role="button"]:after {
  //   content: "\f0d7";
  //   font-family: FontAwesome;
  //   display: inline-block;
  //   margin-left: 6px;
  // }
  // .monitoring-wrapper > .dropdown > ul {
  //   position: absolute;
  //   z-index: 999;
  //   display: block;
  //   left: -100vw;
  //   top: calc(1.5em + 14px);
  //   border: 1px solid #8c8c8c;
  //   background: #fff;
  //   padding: 6px 0;
  //   margin: 0;
  //   list-style: none;
  //   width: 100%;
  //   -webkit-border-radius: 3px;
  //   -moz-border-radius: 3px;
  //   border-radius: 3px;
  //   -webkit-box-shadow: 0 3px 8px rgba(0,0,0,.15);
  //   -moz-box-shadow: 0 3px 8px rgba(0,0,0,.15);
  //   box-shadow: 0 3px 8px rgba(0,0,0,.15);
  // }
  // .monitoring-wrapper > .dropdown > ul a {
  //   display: block;
  //   padding: 6px 15px;
  //   text-decoration: none;
  //   color: #333;
  // }
  // .monitoring-wrapper > .dropdown > ul a:hover,
  // .monitoring-wrapper > .dropdown > ul a:focus {
  //   background: #ececec;
  // }
  // .monitoring-wrapper > .dropdown > input[type="checkbox"]:checked ~ ul,
  // .monitoring-wrapper > .dropdown > ul:target {
  //   left: 0;
  // }
  // .monitoring-wrapper > .dropdown > [type="checkbox"]:checked + label:after,
  // .monitoring-wrapper > .dropdown > ul:target ~ a:after {
  //   content: "\f0d8";
  // }
  // .monitoring-wrapper > .dropdown a.close {
  //   display: none;
  // }
  // .monitoring-wrapper > .dropdown > ul:target ~ a.close {
  //   display: block;
  //   position: absolute;
  //   left: 0;
  //   top: 0;
  //   height: 100%;
  //   width: 100%;
  //   text-indent: -100vw;
  //   z-index: 1000;
  // }
  // /*
  //  Demo purposes only
  // */
  // *,
  // *:before,
  // *:after {
  //   box-sizing: border-box;
  // }
  // body {
  //   padding: 30px;
  //   color: #333;
  // }
  // .monitoring-wrapper > .dropdown + h2 {
  //   margin-top: 60px;
  // }
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(-90deg);
    }
  }
</style>



// WEBPACK FOOTER //
// SidebarMenu.vue?472046b0